const baseUrl = "https://garage-manager.clouxiplexi.com/api/";
// const baseUrl = "http://127.0.0.1:8000/api/";
// const baseUrl = "http://38.242.212.43:8002/api/";
// const baseUrl = "http://167.86.79.112:8002/api/";
// const baseUrl = "http://165.73.244.174:80/api/";
// export const baseUrlImages = "https://get-tutored.co.uk/backend/";

// Auth
const token = localStorage.getItem('user_token');

export const login = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    // Return the promise generated by fetch
    return fetch(`${baseUrl}auth/login`, requestOptions)
        .then((res) => res.text())
        .then((json) => {
            // 
            return json;
        })
        .catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });
}

export const toggleLogs = (value) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}toggleLogs/${value}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
export const getLogs = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}getLogs`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

//Dashboard
export const getDashboard = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}dashboard`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// Customer Type

export const getAllCustomerType = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}typesOfCustomer/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getCustomerTypeById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}typesOfCustomer/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveCustomerType = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}typesOfCustomer/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateCustomerType = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}typesOfCustomer/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleCustomerType = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}typesOfCustomer/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Insurance Company

export const getAllInsuranceCompany = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceCompany/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getInsuranceCompanyById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceCompany/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveInsuranceCompany = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceCompany/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateInsuranceCompany = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceCompany/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleInsuranceCompany = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceCompany/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Insurance Type

export const getAllInsuranceType = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceType/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getInsuranceTypeById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceType/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveInsuranceType = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceType/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateInsuranceType = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceType/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleInsuranceType = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insuranceType/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Client

export const getAllClient = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}client/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getClientById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}client/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveClient = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}client/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateClient = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}client/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleClient = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}client/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// State

export const getAllState = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}state/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getStateById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}state/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveState = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}state/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateState = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}state/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleState = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}state/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Color

export const getAllColor = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}color/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getColorById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}color/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveColor = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}color/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateColor = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}color/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleColor = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}color/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Vehicle Type

export const getAllVehicleType = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleType/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleTypeById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleType/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVehicleType = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleType/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVehicleType = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleType/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVehicleType = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleType/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Vehicle Make

export const getAllVehicleMake = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleMake/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleMakeById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleMake/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVehicleMake = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleMake/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVehicleMake = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleMake/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVehicleMake = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleMake/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getAllVendors = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vendor/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVendorById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vendor/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVendor = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vendor/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVendor = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vendor/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVendor = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vendor/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getAllCoverage = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}coverage/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getCoverageById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}coverage/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveCoverage = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}coverage/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleCoverage = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}coverage/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateCoverage = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}coverage/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Payment Type

export const getAllPaymentType = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}paymentType/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getPaymentTypeById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}paymentType/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const savePaymentType = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}paymentType/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const togglePaymentType = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}paymentType/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updatePaymentType = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}paymentType/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Police Station

export const getAllPoliceStation = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeStation/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getPoliceStationById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeStation/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const savePoliceStation = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeStation/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const togglePoliceStation = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeStation/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updatePoliceStation = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeStation/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Vehcile

export const getAllVehicle = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicle/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicle/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVehicle = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicle/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVehicle = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicle/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVehicle = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicle/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleByCustomerId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicle/getByCustomerId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Vehicle Code

export const getAllVehicleCode = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleCode/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleCodeById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleCode/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVehicleCode = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleCode/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVehicleCode = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleCode/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVehicleCode = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleCode/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// Vehicle Model

export const getAllVehicleModel = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleModel/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleModelById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleModel/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleModelByMakeId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleModel/getByVehicleMakeId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVehicleModel = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleModel/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVehicleModel = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleModel/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVehicleModel = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleModel/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// Customer

export const getAllCustomer = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}customer/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getAllCustomerLocal = (page, currentRowsPerPage) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}customer/getAllFromLocal?page=${page}&items=${currentRowsPerPage}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getCustomerById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}customer/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveCustomer = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}customer/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleCustomer = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}customer/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateCustomer = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}customer/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// Supplier

export const getAllSupplier = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}supplier/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getSupplierById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}supplier/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveSupplier = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}supplier/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleSupplier = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}supplier/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateSupplier = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}supplier/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// ProductCategory

export const getAllProductCategory = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}productCategory/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getProductCategoryById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}productCategory/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveProductCategory = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}productCategory/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleProductCategory = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}productCategory/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateProductCategory = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}productCategory/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Products

export const getAllProduct = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getProductById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getProductByCategoryId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/getByCategoryId/?category_id=${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveProduct = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleProduct = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateProduct = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Investigation

export const getAllInvestigation = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };

    let res = fetch(`${baseUrl}investigation/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions)
        .then((res) => res.text())
        .then((json) => {
            // 
            return json;
        })
        .catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}


export const getAllParallelInvestigation = (page, currentRowsPerPage, parallelFilter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (parallelFilter !== "") {
        const filterJson = JSON.stringify(parallelFilter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}investigation/getAllParallel?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getInvestigationById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}investigation/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getInvestigationByVehicleReplacementId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}investigation/getByVehicleReplacementId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveInvestigation = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}investigation/save`, requestOptions).then((res) => res.text())
        .then((json) => {

            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleInvestigation = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}investigation/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateInvestigation = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}investigation/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Estimate

export const getAllEstimate = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getAllParallelEstimate = (page, currentRowsPerPage, parallelFilter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (parallelFilter !== "") {
        const filterJson = JSON.stringify(parallelFilter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/getAllParallel?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getEstimateById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getEstimateByInvestigationId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/getByInvestigationId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveEstimate = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleEstimate = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateEstimate = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// PoliceReport

export const getAllPoliceReport = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeReport/getAll`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getPoliceReportById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeReport/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const savePoliceReport = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}policeReport/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const togglePoliceReport = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeReport/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updatePoliceReport = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}policeReport/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// DrivingLicense

export const getAllDrivingLicense = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}drivingLicense/getAll`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getDrivingLicenseById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}drivingLicense/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveDrivingLicense = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}drivingLicense/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleDrivingLicense = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}drivingLicense/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateDrivingLicense = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}drivingLicense/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// Lpo

export const getAllLpo = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}lpoClaim/getAll`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getLpoById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}lpoClaim/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveLpo = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}lpoClaim/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleLpo = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}lpoClaim/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateLpo = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}lpoClaim/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// JobCard

export const getAllJobCard = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getAllParallelJobCard = (page, currentRowsPerPage, parallelFilter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (parallelFilter !== "") {
        const filterJson = JSON.stringify(parallelFilter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getAllParallel?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getJobCardById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getSaleOrderByInsuranceId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getSaleOrderByInsuranceId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getSaleOrderByCustomerId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getSaleOrderByCustomerId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getJobCardByEstimateId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getByEstimateId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getJobCardByInsuranceCompanyId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getByInsuranceCompanyId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getJobLatestId = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/latestId`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveJobCard = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}jobCard/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const generatePurchaseOrders = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/generatePurchaseOrder`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const savePerformaInvoice = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}performaInvoice/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleJobCard = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateJobCard = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getProductAttributes = (page, currentRowsPerPage) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/getAttributes?page=${page}&items=${currentRowsPerPage}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getProductAttributesValue = (page, currentRowsPerPage) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}product/getAttributesValue?page=${page}&items=${currentRowsPerPage}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// Performa Invoice
export const getAllPerformaInvoice = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}performaInvoice/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getPerformaInvoiceById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}performaInvoice/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getInvoicesByPartnerId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}invoices/getByPartnerId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
export const updatePerformaInvoice = (id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}performaInvoice/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// PoliceReport

export const getAllAccidentType = (page, currentRowsPerPage) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}accidentType/getAll?page=${page}&items=${currentRowsPerPage}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveAccidentType = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}accidentType/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Driver

export const getAllDriver = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}driver/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getDriverById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}driver/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveDriver = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}driver/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateDriver = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}driver/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleDriver = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}driver/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// ReplaceableVehicle

export const getAllReplaceableVehicle = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}replaceableVehicle/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getReplaceableVehicleById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}replaceableVehicle/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveReplaceableVehicle = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}replaceableVehicle/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleReplaceableVehicle = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}replaceableVehicle/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateReplaceableVehicle = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}replaceableVehicle/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
// VehicleReplacement

export const getAllVehicleReplacement = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}
export const getAllLeasePlan = (page, currentRowsPerPage) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}leaseCompany/getAll?page=${page}&items=${currentRowsPerPage}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleReplacementById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getTechnicalReportById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/getTechnicalReportById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getVehicleReplacementByDriverId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/getByDriverId/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveVehicleReplacement = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleVehicleReplacement = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateVehicleReplacement = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const passOn = (id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/passOn/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateByAdmin = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}vehicleReplacement/updateByAdmin/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveTechincalReport = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/technicalReport/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const assignDriverOut = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/assignDriverOut/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveFromDriver = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            'Accept': 'application/json',
        },
        body: data,
    };
    let res = fetch(`${baseUrl}vehicleReplacement/save/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const doneByDriver = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}vehicleReplacement/done/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Batch

export const getAllBatch = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}batch/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getBatchById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}batch/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveBatch = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}batch/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateBatch = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}batch/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleBatch = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}batch/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// LeaseBatch

export const getAllLeaseBatch = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }


    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}leaseBatch/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getLeaseBatchById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}leaseBatch/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveLeaseBatch = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}leaseBatch/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateLeaseBatch = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}leaseBatch/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleLeaseBatch = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}leaseBatch/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Parallel Jobs

export const getAllParallelJob = (page, currentRowsPerPage) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}parallelJob/getAll?page=${page}&items=${currentRowsPerPage}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getParallelJobById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}parallelJob/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const saveParallelJob = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}parallelJob/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateParallelJob = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}parallelJob/edit/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const toggleParallelJob = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}parallelJob/toggleStatus/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Users

export const getAllUsers = (page, currentRowsPerPage, filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}users/getAll?page=${page}&items=${currentRowsPerPage}&filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}


export const saveUser = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}user/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getUserById = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}user/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const updateUser = (data, id) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}user/update/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// Permissions

export const getAllPermissions = () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}permissions/getAll`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const savePermissions = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}permissions/save`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const getPermissionsByUserId = (id) => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}permissions/getById/${id}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {

            // ADD THIS THROW error
            throw error;
        });

    return res;
}

export const bulkJobOut = (data) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}bulkJobOut`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });

    return res;
}

// getInsuranceStatement
export const getInsuranceStatement = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}insurance-report?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}

//INVESTIGATION SCHEDULE
export const getInvestigationSchedule = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}investigation/getSchedule?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}
//Estimate SCHEDULE
export const getEstimateSchedule = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}estimate/getSchedule?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}
//Price Statement
export const getPriceStatement = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}price-statement-report?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}
//Job Card SCHEDULE
export const getJobCardSchedule = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/getSchedule?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}
//Price Statement
export const getCostStatement = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}cost-statement-report?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}
//Statement Meethaq Takaful Insurance
export const getStatementMeethaqTakafulInsurance = (filter) => {
    // Convert the filter object to a JSON string
    let encodedFilter = '';
    if (filter !== "") {
        const filterJson = JSON.stringify(filter);
        // URL-encode the JSON string
        encodedFilter = encodeURIComponent(filterJson);
    }
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        },
        // body: JSON.stringify(data),
    };
    let res = fetch(`${baseUrl}jobCard/insuranceStatement?filter=${encodedFilter}`, requestOptions).then((res) => res.text())
        .then((json) => {
            // 
            return json;
        }).catch(function (error) {
            // ADD THIS THROW error
            throw error;
        });
    return res;
}